export const strongPasswordPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

export const passwordGuidance =
  'Usa al menos 12 caracteres e incluye mayúscula, minúscula, número y símbolo.';

export function passwordsMatch(password: string, confirmation: string): boolean {
  return password === confirmation;
}
